import apiClient from '.';
import { IUserPreferences } from '../../app-state/slices/AuthSlice';

export const getUserPreferences = async () => {
    try {
        const { data } = await apiClient.get(`users/preferences`, {});
        return data || {};
    } catch (e: any) {
        return { error: e?.response?.data?.error };
    }
};

export const updateUserPreferences = async (preferences: IUserPreferences) => {
    try {
        const { data } = await apiClient.post(`users/preferences`, {
            data: {
                preferences: { ...preferences },
            },
        });
        return data || {};
    } catch (e: any) {
        return { error: e?.response?.data?.error };
    }
};
